var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"text-center",class:[{ editable: _vm.editing }],attrs:{"id":_vm.item.id,"data-fields":"icon=icon&title=txt&subtitle=txt"}},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.item.title))]),_c('p',[_vm._v(_vm._s(_vm.item.subtitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }